import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { Genre } from 'src/Types/tracks'
import { api } from 'src/Services/api'
import { APP } from 'src/Configs/App'

import { ErrorCode, NameSpace } from '../types'

interface SpotifyArtistGenresBody {
  artistId: string
}

interface SpotifyArtistGenreResponse {
  artist_genres: Array<{
    id: number
    genre_name: string
    PlaylistGenres: Array<Genre>
  }>
}

export interface ArtistConnection {
  artist_id: number
  artist_spotify_id: string
  confirmation_time: string
  id: number
  is_connected: boolean
  sfa_account_id: number
}

interface ArtistSpotifyConnectionsResponse {
  connections: Array<ArtistConnection>
  sfa_email: string
}

interface SetSpotifyConnectionBody {
  artist_spotify_id: string
}

interface SetSpotifyConnectionResponse {
  connection: ArtistConnection
}

export const getArtistGenres = createAsyncThunk<
  SpotifyArtistGenreResponse,
  SpotifyArtistGenresBody
>(
  `${NameSpace.Artists}/getArtistGenres`,
  async ({ artistId }, { rejectWithValue }) => {
    try {
      const { data } = await api.get<SpotifyArtistGenreResponse>(
        `${APP.SERVER}/campaign/spotify-artist-genres/${artistId}/with_playlists`,
      )
      return data
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)

export const removeTikTokAlert = createAsyncThunk(
  `${NameSpace.Artists}/removeTikTokAlert`,
  async (_, { rejectWithValue }) => {
    try {
      await api.put(`${APP.SERVER}/artist/remove-tiktok-alert`)

      return true
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)

export const getArtistSpotifyConnections =
  createAsyncThunk<ArtistSpotifyConnectionsResponse>(
    `${NameSpace.Artists}/getArtistSpotifyConnections`,
    async (_, { rejectWithValue }) => {
      try {
        const { data } = await api.get<ArtistSpotifyConnectionsResponse>(
          `${APP.SERVER}/artist/spotify-connections`,
        )
        return data
      } catch (error) {
        const { message, response } = error as AxiosError
        return rejectWithValue({
          message,
          code: response?.status || ErrorCode.InternalServerError,
        })
      }
    },
  )

export const setSpotifyConnectionForArtist = createAsyncThunk<
  SetSpotifyConnectionResponse,
  SetSpotifyConnectionBody
>(
  `${NameSpace.Artists}/setSpotifyConnectionForArtist`,
  async ({ artist_spotify_id }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<SetSpotifyConnectionResponse>(
        `${APP.SERVER}/artist/spotify-connection`,
        {
          artist_spotify_id,
        },
      )
      return data
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)
